import React, {
  RefObject,
  useState,
} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Table from 'core/components/VirtualTable';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import dayjs from 'utils/dayjs';
import {
  getBulkClaims,
} from 'pages/Dashboard/pages/Billing/api';
import DateRangePicker from 'core/components/DateTimePicker/DateRangePicker';
import {
  useTableReset,
} from 'core/hooks';
import {
  BulkPaperClaimsDTO,
} from 'dtos';
import columns from 'pages/Dashboard/pages/Billing/Charges/bulkClaimsColumns';
import useSignalREffect from 'views/EMR/hooks/signalR';
import {
  SidePanelComponentProps,
} from 'pages/Dashboard/contexts/sidePanel';
import ToolTip from 'core/components/Tooltip';
import {
  DateRange,
} from 'types/dateRange';

export default function BulkClaimsPanel({ onClose }: SidePanelComponentProps) {
  const now = dayjs().startOf('day');
  const { reset, tableInstanceRef } = useTableReset();
  const [dateRange, setDateRange] = useState<DateRange>({
    min: now.subtract(6, 'months').toDate(),
    max: now.toDate(),
  });
  useSignalREffect('OnBulkPaperClaimsCompleted', () => {
    tableInstanceRef.current?.refetch?.();
  });

  return (
    <div className="flex flex-col h-full w-full pt-4 gap-4">
      <div className="px-4 w-full flex items-center justify-between">
        <h3 className="font-semibold text-xl">Bulk Paper Claims</h3>
        <ToolTip title="Close">
          <IconButton
            size="small"
            onClick={onClose}
          >
            <CloseIcon className="!w-5 !h-5 !text-inherit" />
          </IconButton>
        </ToolTip>
      </div>
      <div className="px-4">
        <DateRangePicker
          value={dateRange}
          onChange={(dateRange) => {
            if (dateRange) {
              setDateRange(dateRange);
              reset();
            }
          }}
        />
      </div>
      <div className="flex flex-1 overflow-hidden">
        <Table<BulkPaperClaimsDTO>
          defaultPagination={{
            pageSize: 25,
            pageIndex: 0,
          }}
          instanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
          queryParams={{ dateRange }}
          columns={columns}
          getData={getBulkClaims}
          classes={{
            header: 'px-4',
            outerRow: '!w-[calc(100%-16px)] left-4',
            windowsClassName: '!w-full',
          }}
        />
      </div>
    </div>
  );
}
